/* ---------- MCC-001's unit doors bonded to their earthing busbars (#3956, as CP-002's and BS-001's, #3525) ----------
 * Each unit's door has its earth stud (-XE281, -XE261, -XE211), given, on a strap of its own from the unit's earthing busbar (unit.ts,
 * units.ts). A save made before holds a unit wired without it, which the Wiring step would now call missing. How such a save is read:
 * the save migration in packages/progress uses this (format 40). Self-contained on purpose, as plug.ts: the migration imports this
 * file alone, not MCC-001's pack. */

/** Each unit's strap, as its wiring list has it: -QA28's record in ui.build, -QA26's and -QA21's in ui.builds. */
export const MCC001_DOOR_STRAPS = {
  u28: { from: "PE280:4", to: "XE281:PE" }, u26: { from: "PE260:4", to: "XE261:PE" }, u21: { from: "PE210:4", to: "XE211:PE" },
} as const;

/** A build record ({ placements, wires }) with its door's strap where the busbar is placed and already wired: the unit changed under
 *  the learner's work, so its strap comes with it, as CP-002's (format 30). The Wiring step gives it the list's size, colour and mark
 *  when it loads. Anything else (the busbar not placed or not wired yet, the strap already there) keeps its wires. */
function build(b: any, strap: { from: string; to: string }): any {
  const bar = strap.from.split(":")[0];
  const wires: any[] = Array.isArray(b?.wires) ? b.wires : [], placed = (Array.isArray(b?.placements) ? b.placements : []).some((p: any) => p?.tag === bar);
  const onBar = wires.some(w => [w?.from, w?.to].some(e => typeof e === "string" && e.startsWith(`${bar}:`)));
  const there = wires.some(w => [w?.from, w?.to].sort().join("|") === [strap.from, strap.to].sort().join("|"));
  return placed && onBar && !there ? { ...b, wires: [...wires, { from: strap.from, to: strap.to }] } : b;
}

const one = (ui: any): any => {
  if (!ui || typeof ui !== "object") return ui;
  const builds = ui.builds && typeof ui.builds === "object"
    ? Object.fromEntries(Object.entries(ui.builds).map(([u, b]) => [u, u === "u26" || u === "u21" ? build(b, MCC001_DOOR_STRAPS[u]) : b])) : ui.builds;
  return { ...ui, ...(ui.build ? { build: build(ui.build, MCC001_DOOR_STRAPS.u28) } : {}), ...(ui.builds ? { builds } : {}) };
};
/** A saved MCC-001 project ({ model, ui }) with each unit's door strap: its own work and each earlier attempt it keeps. */
export function doorBondMcc001Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = s?.ui ? { ...s, ui: one(s.ui) } : s;
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => a?.ui ? { ...a, ui: one(a.ui) } : a) } : out;
}
